import { PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';
import { usePaginationContext } from 'utils/contexts/pagination';

export const CreativeLibraryPaginationFooter = ({ assetsCount }: { assetsCount: number }) => {
  const {
    currentPage,
    pageSize: itemsPerPage,
    setPageSize,
    setCurrentPage,
  } = usePaginationContext();

  const handlePaginationUpdate = ({ page, pageSize }: PaginationUpdateEvent): void => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <PaginationFooter
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      numItems={assetsCount}
      onUpdate={handlePaginationUpdate}
    />
  );
};
